import React, { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
// MUI
import { FormControl, Dialog, TextField, Button, Divider, AppBar, Toolbar, Slide, Snackbar, Alert, IconButton, Typography, Paper, Stack, styled, Modal, Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
// SunEditor
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import { editorOptions } from "../resources/Editor.Config";
import { handleEditorPaste, ensureContentSpacing } from "./EditorOptions";

import "./ContentPreview.css";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function ContentEditor({ open, operation, contenttitle, setContenttitle, contentduration, setContentduration, content, setContent, index, onSave, onClose }) {
  const editorRef = useRef(null);

  const editorOnClose = () => {
    onReset();
    onClose();
  };

  const onReset = () => {
    setContent("");
    setContenttitle("");
    setContentduration(0);
    // clear editor contents
    // editorRef.current.editor.setContents("");
  };
  const handleSave = () => {
    let formattedContent = ensureContentSpacing(content);
    let data = { operation, index, contenttitle, contentduration, content: formattedContent };
    onSave(data);
    //onReset();
  };

  return (
    <>
      <Dialog fullScreen open={open} onClose={editorOnClose} TransitionComponent={Transition}>
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={editorOnClose} aria-label="close">
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              Content Editor
            </Typography>
            <Button autoFocus color="inherit" onClick={onReset}>
              reset
            </Button>
            <Button autoFocus color="inherit" onClick={handleSave}>
              save
            </Button>
          </Toolbar>
        </AppBar>
        <div>
          <FormControl sx={{ m: 1, minWidth: 450 }} size="small">
            <TextField id="title" label="Content title" name="title" value={contenttitle} onChange={(e) => setContenttitle(e.target.value)} size="small" autoComplete="title" margin="normal" required autoFocus />
          </FormControl>
          <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
            <TextField id="duration" label="Duration in Minute(s)" name="duration" value={contentduration} onChange={(e) => setContentduration(e.target.value)} size="small" autoComplete="duration" margin="normal" required />
          </FormControl>
          <div>
            <SunEditor ref={editorRef} setOptions={editorOptions} setContents={content} onChange={setContent} onPaste={handleEditorPaste} />
          </div>
        </div>
      </Dialog>
    </>
  );
}

export default ContentEditor;
